import { render, staticRenderFns } from "./NuevoContenedorModalComponent.vue?vue&type=template&id=0c04b32a&"
import script from "./NuevoContenedorModalComponent.vue?vue&type=script&lang=js&"
export * from "./NuevoContenedorModalComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports